import { lazy } from "react";

/**
 * Markdown エディタ・表示の遅延読み込み。エディタは重いので初期表示には入れず、
 * ホームが表示されたあと(ブラウザの空き時間)に先読みして、メモを開いたときに待たせない。
 */
const load = () => import("./MarkdownEditor");

export const LazyMarkdownEditor = lazy(() => load().then((m) => ({ default: m.MarkdownEditor })));
export const LazyMarkdownView = lazy(() => load().then((m) => ({ default: m.MarkdownView })));

let preloaded = false;
/** 先読みする(何度呼んでもよい)。失敗しても、開いたときの通常の読み込みに任せる。 */
export function preloadMarkdown(): void {
  if (preloaded) return;
  preloaded = true;
  void load().catch(() => {
    preloaded = false;
  });
}

/** ブラウザが空いたときに先読みを始める。 */
export function preloadMarkdownWhenIdle(): () => void {
  const w = window as Window & {
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    cancelIdleCallback?: (id: number) => void;
  };
  if (w.requestIdleCallback && w.cancelIdleCallback) {
    const id = w.requestIdleCallback(preloadMarkdown, { timeout: 2000 });
    return () => w.cancelIdleCallback?.(id);
  }
  const id = window.setTimeout(preloadMarkdown, 500);
  return () => window.clearTimeout(id);
}
